// removed by extract-text-webpack-plugin
module.exports = {"columnTip":"index__columnTip___10Pmu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/FilterCriteria/components/Header/index.less
// module id = 1886
// module chunks = 3